import { AuthPartialStoreState } from '../auth.reducer';

export const getRegisterLoaded = (state: AuthPartialStoreState) => state.auth.register.loaded;

export const getRegisterError = (state: AuthPartialStoreState) => state.auth.register.error;

export const getRegistrationSteps = (state: AuthPartialStoreState) => state.auth.register.registrationSteps;

export const getRegistrationProgress = (state: AuthPartialStoreState) => state.auth.register.registrationProgress;

export const getAuthAccessToken = (state: AuthPartialStoreState) => state.auth.register.authAccessToken;
